import React from 'react'
import { useDeleteRouteTemplate, RouteTemplate } from '@/features/templates'
import { getRouteRuntimeLabel, getRouteTypeLabel } from '@/app/routes/Dashboard/Dashboard.hooks'
import { RouteType, Runtime, TemplateStatus } from '@/config/app'
import { Cell, Row as TableRow } from '@/components/ui/Table'
import { formatDate } from '@/utils/string'
import ConfirmTooltip from '@/components/ConfirmTooltip'
import DeleteButton from '@/components/ui/Buttons/DeleteButton'
import { getRouteTemplateStatusLabel, useOpenTemplate } from '@/app/routes/Templates/Templates.hooks'
import { TemplateIdCell } from '@/app/routes/Templates/TemplateIdCell'

export type TemplateItemProps = { template: RouteTemplate }

export const TemplateItem = ({ template }: TemplateItemProps) => {
  const openTemplate = useOpenTemplate(template.id!)
  const deleteTemplate = useDeleteRouteTemplate(template.id!)
  const runtime = getRouteRuntimeLabel(template.runtime as Runtime)
  const type = getRouteTypeLabel(template.type as RouteType)
  const status = getRouteTemplateStatusLabel(template.status as TemplateStatus)

  return (
    <TableRow onClick={openTemplate}>
      <TemplateIdCell templateId={template.id!} />
      <Cell size={3}>{template.name}</Cell>
      <Cell>{runtime}</Cell>
      <Cell>{type}</Cell>
      <Cell>{status}</Cell>
      <Cell>{formatDate(template.createdAt)}</Cell>
      <Cell>{formatDate(template.updatedAt)}</Cell>
      <Cell size={'80px'} isCentered>
        <ConfirmTooltip>
          <DeleteButton onClick={() => deleteTemplate.mutate()} isLoading={deleteTemplate.isPending} />
        </ConfirmTooltip>
      </Cell>
    </TableRow>
  )
}
